import { render, staticRenderFns } from "./batchprint.vue?vue&type=template&id=7c2684d6&scoped=true&"
import script from "./batchprint.vue?vue&type=script&lang=js&"
export * from "./batchprint.vue?vue&type=script&lang=js&"
import style0 from "./batchprint.vue?vue&type=style&index=0&id=7c2684d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2684d6",
  null
  
)

export default component.exports